import React from 'react';
import { SecureHeader } from '../components/checkout/SecureHeader';
import { WelcomeSection } from '../components/checkout/WelcomeSection';
import { ProductSummaryCard } from '../components/checkout/ProductSummaryCard';
import { PaymentForm } from '../components/checkout/PaymentForm';
import { PayButton } from '../components/checkout/PayButton';
import { TrustBadges } from '../components/checkout/TrustBadges';
import { GuaranteeBox } from '../components/checkout/GuaranteeBox';
import { MiniFAQ } from '../components/checkout/MiniFAQ';
import { UrgencyNotice } from '../components/checkout/UrgencyNotice';
import { FooterSupport } from '../components/checkout/FooterSupport';
export function CheckoutPage() {
  return <div className="min-h-screen bg-warm-white" data-id="element-558">
      <SecureHeader data-id="element-559" />

      <main className="pb-12" data-id="element-560">
        <WelcomeSection data-id="element-561" />
        <ProductSummaryCard data-id="element-562" />
        <PaymentForm data-id="element-563" />
        <PayButton data-id="element-564" />
        <TrustBadges data-id="element-565" />
        <GuaranteeBox data-id="element-566" />
        <MiniFAQ data-id="element-567" />
        <UrgencyNotice data-id="element-568" />
      </main>

      <FooterSupport data-id="element-569" />
    </div>;
}